import React from 'react';

const LoadingFallback = () => {
  return (
    <div className="loading-fallback">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingFallback;
